module.exports = __webpack_public_path__ + "static/media/Grass.48de8555.gif";